module.exports = __webpack_public_path__ + "static/media/speaker-info.acc6d79a.jpg";